<ng-template #otpModal let-modal>
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                (click)="closeOtpModal()"></button>
        </div>
        <div class="modal-body">

            <div class="card-body text-center">
                <div>
                    <ng-template #otpInputTemplate let-sendTo="sendTo" let-maskValue="maskValue"
                        let-onOtpChange="onOtpChange" let-resendOtp="resendOtp" let-isTimerVisible="isTimerVisible"
                        let-timer="timer" let-enteredOTP="enteredOTP">

                        <div
                            [ngClass]="{ 'mt-5': (sendTo == 'email' && otpParameters.sendTo == helper.OTPSendMode.SMS_EMAIL)}">


                            <div class="text-start mx-5">
                                <h4 class="text-primary otp-heading">
                                    @if(isVerifyOtp && sendTo == 'phone') {
                                    {{ "label-title.verify-phone" | translate | titlecase }}
                                    } @else if (isVerifyOtp && sendTo == 'email') {
                                    {{ "label-title.verify-email" | translate | titlecase }}
                                    } @else {
                                    {{ "label-title.otp-verification" | translate | titlecase }}
                                    }
                                </h4>
                                <p class="otp-description">{{ "label-title.please-enter-the-6-digit-code-sent-to" |
                                    translate }}<br>
                                    <span class="otp-sent-to">
                                        {{ maskValue }}
                                    </span>
                                </p>
                            </div>

                            <div class="mt-4 mb-2">
                                <div class="row twostep-input mb-3">
                                    <ng-otp-input (onInputChange)="onOtpChange($event)"
                                        [config]="config"></ng-otp-input>
                                </div>

                                <p class="resend text-start text-muted mx-5">
                                    {{ 'label-title.not-receive-code' | translate }}
                                    <ng-container *ngIf="!isTimerVisible; else waitTemplate">
                                        <a class="c-pointer" (click)="resendOtp()">
                                            {{ 'label-title.request-again' | translate }}
                                        </a>
                                    </ng-container>
                                    <ng-template #waitTemplate>
                                        <a href="javascript:void(0);">
                                            {{ 'label-title.wait' | translate | titlecase }} {{ timer }} {{
                                            'label-title.seconds' | translate
                                            }}
                                        </a>
                                    </ng-template>
                                </p>
                            </div>
                        </div>
                    </ng-template>

                    <!-- Phone Verification -->
                    <ng-container
                        *ngIf="otpParameters.sendTo == helper.OTPSendMode.SMS || otpParameters.sendTo == helper.OTPSendMode.SMS_EMAIL">
                        <ng-container
                            *ngTemplateOutlet="otpInputTemplate; context: { sendTo: 'phone', maskValue: otpParameters?.countryPhoneCode + ' ' + helper.maskPhoneNumber(otpParameters?.phone), onOtpChange: onOtpChangePhone.bind(this), resendOtp: resendOtpPhone.bind(this), isTimerVisible: isTimerVisiblePhone, timer: timerPhone, enteredOTP: enteredPhoneOTP }"></ng-container>
                    </ng-container>

                    <!-- Email Verification -->
                    <ng-container
                        *ngIf="otpParameters.sendTo == helper.OTPSendMode.EMAIL || otpParameters.sendTo == helper.OTPSendMode.SMS_EMAIL">
                        <ng-container
                            *ngTemplateOutlet="otpInputTemplate; context: { sendTo: 'email', maskValue: helper.maskEmail(otpParameters?.email), onOtpChange: onOtpChangeEmail.bind(this), resendOtp: resendOtpEmail.bind(this), isTimerVisible: isTimerVisibleEmail, timer: timerEmail, enteredOTP: enteredEmailOTP }"></ng-container>
                    </ng-container>
                </div>

                <div class="text-center mx-5">
                    <button class="w-100 btn btn-secondary mt-3" id="verifyButton" (click)="verify()"
                        [disabled]="
            (otpParameters.sendTo === helper.OTPSendMode.SMS && enteredPhoneOTP.length !== 6) ||
            (otpParameters.sendTo === helper.OTPSendMode.EMAIL && enteredEmailOTP.length !== 6) ||
            (otpParameters.sendTo === helper.OTPSendMode.SMS_EMAIL && (enteredPhoneOTP.length !== 6 || enteredEmailOTP.length !== 6))">
                        {{ 'label-title.verify' | translate | titlecase }}
                    </button>
                </div>


            </div>

        </div>
    </div>
</ng-template>